import React, { useContext, useState, useEffect } from "react";
// import { ToastContainer } from "react-bootstrap";
import Breadcrumb from "../Generic/Breadcrumb";
import { loginRequest } from "../Redux/API";
import { ClipLoader } from "react-spinners";
import { AppContext } from "../Redux/ContextProvider";
import { Link, useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";

function Login() {
  const { appState, dispatch } = useContext(AppContext);
  const isAuthenticated = localStorage.getItem("loggedInEmail");
  const { loginInfo, loginLoader, loginMessage } = appState;
  const location = useLocation();
  const [loginInput, setLoginInput] = useState({
    ClientId: 48,
    email_id: "",
  });
  const [error, setError] = useState("");
  const history = useHistory();
  // console.log(history?.location.state?.IndirectAccess);
  useEffect(() => {
    scrollTo();
  });
  useEffect(() => {
    if (loginMessage !== "") {
      setError(loginMessage);
    }
    if (loginInfo.status === "success") {
      const redirectPath = location?.state?.from || "/";
      history.push(redirectPath);
    }
  }, [loginMessage, loginInfo]);
  const scrollTo = () => {
    window.scrollTo({
      top: 120,
      behavior: "smooth",
    });
  };
  const login = (e) => {
    e.preventDefault();
    loginRequest(appState, dispatch, loginInput);
  };
  const loginData = (e) => {
    setError("");
    setLoginInput({ ...loginInput, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    isAuthenticated === null &&
      history.location.state?.IndirectAccess === true &&
      toast("Please Login to access this page");
  }, []);
  return (
    <>
      <ToastContainer />
      {loginLoader ? (
        <div className="home-spinner">
          <ClipLoader color={"#2A5350"} loading={true} size={60} />
        </div>
      ) : (
        <>
          <Breadcrumb pageName={"Login"} pageTitle={"Login"} id={`#$Login`} />
          <ToastContainer />
          <div className="form-section mb-50" id="login" ref={scrollTo}>
            <div className="container">
              <div className="row d-flex justify-content-center">
                <div className="col-lg-6 col-sm-6 col-12">
                  <div className="section-title2 primary3 text-start">
                    <h2>Login</h2>
                  </div>
                <div className="glass-effect space">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <div className="row g-4">
                      <div className="col-lg-12">
                        <div className="form-inner">
                          <label
                          className="form-label"
                            htmlFor="email"
                            style={{ marginBottom: "10px" }}
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            name="email_id"
                            id="email"
                            placeholder="Please Enter your email"
                            className={`input ${"is-danger"}`}
                            onChange={loginData}
                          />
                          {error && (
                            <p
                              className="help is-danger"
                              style={{
                                color: "red",
                                fontSize: "12px",
                                padding: "2px",
                              }}
                            >
                              {error}
                            </p>
                          )}
                        </div>
                          <button className="eg-btn btn--primary2 capsule mt-20 " onClick={login}>
                            Login<CustomButton />
                          </button>
                      </div>
                      <div className="col-lg-12 login-extra-links">
                      {/* <Link to="/registration" className="register-link" >Click for Registration</Link> */}
                      <Link to="/" className="guest-link" >Continue as Guest
                      </Link>
                      </div>
                    </div>
                  </form>
                </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
export default Login;
